import { useEntity } from '@uswitch/ev-utils/lib/context/selectors'
import { Container } from '@uswitch/ev-core/react'
import Hero from '../../elements/hero'

import { cf2imgix } from '../../elements/imgix-img'
import Breadcrumb from '../../compounds/breadcrumb'
import Grid from '../../compounds/grid/grid-from-json.connected'

const ConnectedHero = props => {
  const { imagePosition } = props
  const image = useEntity(props.image)

  const breadcrumbs = <Breadcrumb entity={props.breadcrumbs} />

  return (
    <Hero
      breadcrumbs={props.breadcrumbs && breadcrumbs}
      container={Container}
      fgImage={cf2imgix(image?.file?.url)}
      fgImagePosition={imagePosition.position}
      fgImageType={imagePosition.imageType}
      fgImageOnMobile={imagePosition.displayOnMobile}
      variant={props.variant}
    >
      <Grid {...props} />
    </Hero>
  )
}

export default ConnectedHero
